import GeneralErrorModal from './GeneralErrorModal';

export default GeneralErrorModal;
